// What a fax's schema chip says on hover: which TABLE it matched in there.
//
// A matched fax is filed twice — onto the visit in `notes-c`, and onto the
// patient's chart row in `patients_with_ehrid` — and either half can be absent:
// a patient with a chart row but no upcoming visit gets only the second, a
// visit for someone not on the roster only the first. Naming the schema alone
// left "filed to SOC_WORK" ambiguous about what was actually reached there.
//
// The backend derives this from the storage paths (annotate_matched_schemas)
// because the two filings use different folder shapes.
//
// Kept to a few words: this is a hover on a chip the user is scanning, not
// somewhere to explain the filing model.

const NOTES = "notes-c";
const ROSTER = "patients_with_ehrid";

/**
 * Which tables, in as few words as possible. Null when unknown.
 *
 * @param tables e.g. ["notes-c", "patients_with_ehrid"]
 */
export function matchedTablesLabel(tables) {
  const set = new Set(Array.isArray(tables) ? tables : []);
  const notes = set.has(NOTES);
  const roster = set.has(ROSTER);
  if (notes && roster) return "notes-c + patients table";
  if (notes) return "notes-c";
  if (roster) return "patients table";
  return null;
}

/**
 * The schema chip's tooltip: just the table(s) the fax matched there.
 *
 * `viewingSchema` is kept in the signature (and unused) because the chip
 * already distinguishes the viewed inbox visually — bold text, darker fill —
 * so naming it in the tooltip too was noise.
 *
 * @param name          the chip's schema
 * @param viewingSchema the inbox being looked at (unused)
 * @param matchedTables the fax's `matched_tables` map, {schema: [table, ...]}
 */
export function faxSchemaTooltip(name, viewingSchema, matchedTables) {
  // Empty when the API sent no table info: no tooltip beats a made-up one.
  return matchedTablesLabel((matchedTables || {})[name]) || "";
}
